import React from 'react'
import { Link, useLocation } from "react-router-dom";
const Home = () => {
  return (
   <>
    <section id='landing' style={{paddingTop : "50px" , background:"linear-gradient(60deg, rgb(82, 67, 170), rgb(237, 80, 180)) 0% 0% "}} className='flex' >
       <div className="intro w-50">
           <div className="intro-para px-5 text-light" style={{fontSize: "3rem",fontFamily: "system-ui"}}>
             I-manager brings all your tasks, teammates, and tools together
            </div>   
            <div className="font-monospace fs-5 intro-slang px-5 py-4 text-light">
             Keep everything in the same place—even if your team isn't.
            </div> 
           
            <Link to="/signup" type="button"style={{letterSpacing:"2px"}} className="btn btn-primary mx-5 my-4">Sign up - it's free!</Link>
            
       </div>
       <span className="intro-img w-50">
         <img className='w-100' src="https://images.ctfassets.net/rz1oowkt5gyp/75rDABL8fyMtNLlUAtBxrg/c5e145977a86c41c47e17c69410c64f7/TrelloUICollage_4x.png?w=2280&fm=webp" alt="Check your intenet connection" />
       </span>
    </section>
    <section style={{background:" linear-gradient(179deg, rgb(160 173 71 / 12%), rgb(255 255 255)) 0% 0%"}} className="descrption p-5">
      <div className="App-header short-description" style={{minHeight:"50vh"}}>
        <h2 className='fa font-monospace'>A productivity powerhouse</h2>
        <p className='font-monospace fs-5 my-2 w-75'>Simple, flexible, and powerful. All it takes are boards, lists, and cards to get a clear view of who's doing what and what needs to get done. Learn more in our guide for getting started.</p>
      </div>
      <div className="long-description my-5 flex">
        <div className="car-box">
          <div className="card my-3" style={{width: "18rem",borderLeft: "4px solid #97d4d7"}}>
            <div className="font-monospace card-body">
              <h5 className="card-title fs-6 fw-bold">Oraganize yourself</h5>
              <p className="card-text fs-6">Buil your To - DO list and keep it updated whenever you achieve or finshed your work.</p>
            </div>
          </div>
          <div className="card my-3" style={{width: "18rem",borderLeft: "4px solid #97d4d7"}}>
            <div className="font-monospace card-body">
              <h5 className="card-title fs-6 fw-bold">Safe Document</h5>
              <p className="card-text fs-6">Keep your Important Zip/pdf files safe and on your fingertips by storing it on cloud</p>
            </div>
          </div>
          <div className="card my-3" style={{width: "18rem",borderLeft: "4px solid #97d4d7"}}>
            <div className="font-monospace card-body">
              <h5 className="card-title fs-6 fw-bold">Journal Diary</h5>
              <p className="card-text fs-6">Write and maintain your Personal happenings safe and store in your digital diary visit it anytime </p>
            </div>
          </div>
        </div>
        <div className="image-section2" style={{width:"54%"}}>
           <img className='w-100' src="https://tmetric.com/media/qfwptni2/work-schedules-header-banner.png" alt="Please check your network" />
        </div>
      </div>
    </section>
    <section className="new-way py-5" style={{background: "linear-gradient(3deg,darkseagreen, rgb(255, 255, 255)), 0% 0%"}}>
      <div className="new-way-description text-center">
        <h2 style={{fontFamily: "cursive"}}>See work in whole new way</h2>
        <div style={{letterSpacing:"2px",width:"65%",margin:"auto"}}>View your team's projects from every angle and bring a fresh perspective to the task at hand.</div>
        <Link to="/signup" type="button"style={{letterSpacing:"2px"}} className="btn btn-primary mx-5 my-4">Try I-Manager</Link>
      </div>
      <div className="new-way-box">
        <div className="flex justify-content-between main-box p-5">
          <img className='w-50' style={{borderRadius:'6px'}} src="https://meticulousbplans.com/wp-content/uploads/2019/04/product-image_BP-1024x512.png" alt="please check your connection" />
          <div style={{width:"40%"}}>
            <h6 className='fw-semibold'>HIT DEADLINES EVERY TIME</h6>
            <p className='fs-5'>From weekly sprints to annual planning, Timeline view keeps all tasks on track. Quickly get a glimpse of what’s coming down the pipeline and identify any gaps that might impede your team’s progress.</p>
          </div>
        </div>
        <div className="flex flex-lg-row-reverse justify-content-between main-box p-5">
          <img className='w-50'style={{borderRadius:'6px'}} src="https://img.freepik.com/free-vector/business-man-dealing-multi-task-new-idea-working-laptop-concept-business-goals-success-satisfying-achievement_1150-39765.jpg?w=900&t=st=1685012976~exp=1685013576~hmac=35492b621cd8874cd15893caefe68f2cb6590f276f7686e17db70514713ee0e1" alt="please check your connection" />
          <div style={{width:"40%"}}>
            <h6 className='fw-semibold'>STAY ON TOP OF TASKS</h6>
            <p className='fs-5'>Start each day without any surprises. Whether scheduling an editorial calendar or staying on top of to-dos, Calendar view is like a crystal ball giving you a clear vision of what work lies ahead.</p>
          </div>
        </div>
      </div>
    </section>
    <section className="do-more p-4" style={{background: "aliceblue",fontFamily:"system-ui"}}>
      <div className='p-5'>
        <h6 className='fw-bold'>POWERFUL WAYS TO GROW</h6>
        <h3 className='fs-1 fw-semibold my-3'>Do more with I-Manager</h3>
        <p className='fs-5 w-75'>I-Manager’s intuitive features give any team the ability to quickly set up and customize workflows for just about anything.</p>
      </div>
      <div className='flex justify-content-around m-4'>
        <div className="card p-3" style={{width: "20rem"}}>
          <img style={{width: "36%"}} src="https://images.ctfassets.net/rz1oowkt5gyp/gMfkjoA3yWYG3kat3qjpW/3902bfdfccf08869e33d63bbc9d1969b/Integrations_Puzzle.svg" className="card-img-top" alt="..."/>
          <div className="card-body my-4 p-0">
            <h5 className="card-title fw-bold">planning</h5>
            <p className="card-text fs-6">Effective planning helps you organize your time and resources to achieve your goals efficiently. This involves setting clear goals, breaking them down into actionable steps, and allocating time for each task.</p>
          </div>
        </div>
        <div className="card p-3" style={{width: "20rem"}}>
          <img style={{width: "36%"}} src="https://images.ctfassets.net/rz1oowkt5gyp/7wxRW93hvb7858bMsK4LSs/f6fc44fb23dbc6ee9bc6a7f6e2af0fb7/Gears.svg" className="card-img-top" alt="..."/>
          <div className="card-body my-4 p-0">
            <h5 className="card-title fw-bold">Self-Descipline</h5>
            <p className="card-text fs-6">Self-discipline is crucial for sticking to your plans and resisting the urge to procrastinate or get distracted. It involves developing habits that support productivity and consistently following through on your commitments.</p>
           
          </div>
        </div>
        <div className="card p-3" style={{width: "20rem"}}>
          <img style={{width: "36%"}} src="https://images.ctfassets.net/rz1oowkt5gyp/mNa3Mi7T6ga2OTrNxJx1D/8991b8d57cd6ec7330398c7a8757b4dc/Search_Value.svg" className="card-img-top" alt="..."/>
          <div className="card-body my-4 p-0">
            <h5 className="card-title fw-bold">Prioritization</h5>
            <p className="card-text fs-6">Prioritization involves determining what tasks and activities are most important and need immediate attention. This ensures that you're focusing your efforts on activities that align with your goals and have the highest impact.</p>
           
          </div>
        </div>
      </div>
    </section>
    <section style={{    borderTop: ".5px solid #d2d0d0" ,background: "rgb(241, 245, 249)", display: "flex",justifyContent: "flex-end",alignItems: "center",height:" 50px"}} >
      <span style = {{ fontSize: "medium", fontFamily: "monospace" , margin: "0px 25px",cursor:"pointer"}}>Privacy Policy</span>
      <span style = {{ fontSize: "medium", fontFamily: "monospace" , margin: "0px 25px",cursor:"pointer"}}>Terms of Service</span>
    </section>
    </>
  )
}

export default Home
